import React from 'react';

import { stringToCSSObject, transformWithPrefix } from 'helpers/string';

import cx from 'classnames';
import styles from './styles.scss';

export default class Graphic extends React.PureComponent {
  render() {
    const { scale, graphic } = this.props;

    const classes = cx(styles.graphic);
    const rotate = parseInt(graphic.getIn(['options', 'rotate'], 0));

    const style = {
      zIndex: graphic.get('order') ? Math.round(graphic.get('order') * 1000) : 1,
      left: Math.round(graphic.get('x') * scale) + 'px',
      top: Math.round(graphic.get('y') * scale) + 'px',
      width: Math.round(graphic.get('width') * scale) + 'px',
      height: Math.round(graphic.get('height') * scale) + 'px',
      backgroundImage: 'url(' + graphic.get('image') + ')',
      [transformWithPrefix]: rotate ? `rotate(${rotate}deg)` : null,

      ...stringToCSSObject(graphic.getIn(['options', 'css'], '')),
    };

    return <div className={classes} style={style} />;
  }
}



// WEBPACK FOOTER //
// ./app/components/graphic/index.js